import React from 'react'

const InformationPrimary = () => {
    return (
        <form>
            <h2 className="bg-light py-3 translatable">Information primaires</h2>
            <div className="form-group">
                <div className="flex flex-col  space-y-2 form-check  flex flex-row items-center py-3">
                    <input className="form-check-input" type="checkbox" id="disabledFieldsetCheck" />
                    <label className="form-check-label translatable" for="disabledFieldsetCheck">
                        Modfier les element
                    </label>
                </div>
            </div>
            <fieldset>

                <div className="input-group mb-3">
                    <span className="input-group-text translatable" id="basic-addon1">lien facebook </span>
                    <input type="text" className="form-control translatable" placeholder="www.facebook.com" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
                <div className="input-group mb-3">
                    <span className="input-group-text translatable" id="basic-addon1">lien youtube</span>
                    <input type="text" className="form-control translatable" placeholder="www.youtube.com" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
                <div className="input-group mb-3">
                    <span className="input-group-text translatable" id="basic-addon1">lien instagram</span>
                    <input type="text" className="form-control translatable" placeholder="www.instagram.com" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
                <div className="input-group mb-3">
                    <span className="input-group-text translatable" id="basic-addon1">addresse email</span>
                    <input type="text" className="form-control translatable" placeholder="email@gmail.com" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>

                <div className="input-group mb-3">
                    <span className="input-group-text translatable" id="basic-addon1">N° de telephone 1</span>
                    <input type="text" className="form-control translatable" placeholder="+225 XXXXXXXX" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
                <div className="input-group mb-3">
                    <span className="input-group-text translatable" id="basic-addon1">N° de telephone 2</span>
                    <input type="text" className="form-control translatable" placeholder="+225 XXXXXXXX" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
                <div className="input-group mb-3">
                    <span className="input-group-text translatable" id="basic-addon1">N° de telephone 3</span>
                    <input type="text" className="form-control translatable" placeholder="+225 XXXXXXXX" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>
                <div className="input-group mb-3">
                    <span className="input-group-text translatable" id="basic-addon1"> localistation</span>
                    <input type="text" className="form-control translatable" placeholder="123 Street, New York, USA" aria-label="Username" aria-describedby="basic-addon1"
                    />
                </div>


                <div className="input-group mb-3 mt-5">
                    <button type="submit" className=" btn btn-dark bg-dark translatable">Enregistrer changement</button>
                </div>
            </fieldset>
        </form>
    )
}

export default InformationPrimary;